import ProjectStore from '../store/ProjectStore'
import messageResource from '../messageResource'
import CustomerStore from '../store/CustomerStore'
import TaskStore from '../store/TaskStore'
import _ from 'underscore'
import { collectCustomFieldValues } from '../customFields/utils'

export const createdTasksToast = (taskIds, projects, customers) => {
    let message = "";
    if (taskIds.length > 0)
    {
        if (taskIds.length > 1)
            message += messageResource.getMessage("create.tasks.toast", [taskIds.length]);
        else
            message += messageResource.getMessage("create.task.toast", [TaskStore.get(taskIds[0]).name]);

        if (projects.length > 1)
            message += " " + messageResource.getMessage("create.task.toast.project_postfix_plural", [projects.length]);
        else
            message += " " + messageResource.getMessage("create.task.toast.project_postfix_singular", [ProjectStore.get(projects[0]).name]);

        if (customers.length > 1)
            message += " " + messageResource.getMessage("create.task.toast.customer_postfix_plural", [customers.length]);
        else
            message += " " + messageResource.getMessage("create.task.toast.customer_postfix_singular", [CustomerStore.get(customers[0]).name]);
    }
    else
    {
        message = messageResource.getMessage("create.task.toast.no_tasks_created");
    }
    return message;
}

export const customerFromRpc = data => ({
    id: data['id'],
    name: data['name'],
    archived: _.isUndefined(data['archived']) ? !data['activeCustomer'] : data['archived']
})

export const projectFromRpc = data => ({
    id: data['id'],
    name: data['name'],
    customerId: data['customerId'],
    archived: _.isUndefined(data['archived']) ? !data['activeProject'] : data['archived']
})

export const taskFromRpc = data => ({
    id: data['id'],
    name: data['name'],
    projectId: data['projectId'],
    customerId: data['customerId'],
    completed: _.isUndefined(data['open']) ? data['completed'] : !data['open'],
    estimatedTime: data['estimatedTime'],
    deadline: _.isString(data['deadline']) ? Date.parseJSONDate(data['deadline']) : null,
    lastTrackingDate: _.isString(data['lastTTDate']) ? Date.parseJSONDate(data['lastTTDate']) : null,
    workflowStatusId: data['workflowStatusId'],
    typeOfWorkId: data['typeOfWorkId'],
    creationDate: _.isString(data['creationTimestamp']) ? Date.parseJSONDate(data['creationTimestamp']) : null,
    spentTime: data['spentTime'],
    commentsNumber: data['commentsNumber'],
    nextId: data['nextId'],
    variance: data['variance'],
    progress: data['progress'],
    customFieldsValues: data['customFieldsValues'],
})



// WEBPACK FOOTER //
// ./web/js/taskManagement/utils.js